import { Drawer } from '@mui/material';
import { styled } from '@mui/material/styles';

import {
  OPENED_DRAWER_WIDTH,
  CLOSED_DRAWER_WIDTH,
} from 'applications/GSP/layouts/MainLayout/components/Sidebar/constants';
import {
  openedMixin,
  closedMixin,
} from 'applications/GSP/layouts/MainLayout/components/Sidebar/utils';

import type { Theme, CSSObject } from '@mui/material/styles';

const openedDrawerMixin = (theme: Theme): CSSObject => ({
  width: OPENED_DRAWER_WIDTH,
  ...openedMixin({ theme }),
});

const closedDrawerMixin = (theme: Theme): CSSObject => ({
  width: CLOSED_DRAWER_WIDTH,
  ...closedMixin({ theme }),
});

export const DrawerWrapper = styled(Drawer, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  // TODO: make changes due GSP-596 and remove this comment
  width: OPENED_DRAWER_WIDTH,
  '& .MuiPaper-root': {
    display: 'grid',
    gridTemplateRows: 'max-content max-content auto max-content',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    overflowX: 'hidden',
  },
  ...(open && {
    ...openedDrawerMixin(theme),
    '& .MuiDrawer-paper': openedDrawerMixin(theme),
  }),
  ...(!open && {
    ...closedDrawerMixin(theme),
    '& .MuiDrawer-paper': closedDrawerMixin(theme),
  }),
}));
